module.exports = import("https://js.arcgis.com/4.31/@arcgis/core/identity/IdentityManager.js");;